import { Booking } from "src/types";
import i18n from "../i18n";

class BookingService {
  private static _service: BookingService | undefined;

  public static get(): BookingService {
    if (!this._service) {
      this._service = new BookingService();
    }
    return this._service;
  }

  displayName(firstname: string, lastname: string, civility?: number): String {
    let displayNameArray = [
      civility
        ? i18n.t(`instabook.contacts.gender_type.${civility}`)
        : undefined,
      firstname,
      lastname,
    ];

    const displayNameInfo = displayNameArray.filter((element) => {
      return element !== undefined;
    });

    return displayNameInfo.join(" ");
  }
}

export default BookingService.get();
